import {useEffect, useState} from "react";
import {getExistingReview} from "../../services/Technician/equipmentReviewService";

export const useGetExistingReview = (ticketUniqueCode:string, dispenserUniqueCode: string) => {
    const [review, setReview] = useState<any>(null);
    const [additive, setAdditive] = useState<any>(null);

    useEffect(() => {
        const fetchExistingReviewByTicketAndEquipment = async () => {
            try {
                const response: any = await getExistingReview(ticketUniqueCode, dispenserUniqueCode);
                setReview(response.data.review.installedEquipmentReviewValues)
                setAdditive(response.data.review.equipmentAdditive)
            } catch (error) {
                console.error('Error fetching review:', error);
            }
        };
        fetchExistingReviewByTicketAndEquipment();
    }, []);

    return { review, additive };
};
